import { useEffect } from 'react';

export const useQuickCutTimers = ({
  isMobile,
  mobileStage,
  mobileAcceptedUntil,
  mobileRequest,
  setCountdownTick,
  realTimeUpdates,
  quickCutStatus,
  updateQuickCutProgress
}) => {
  useEffect(() => {
    if (!isMobile || mobileStage === 'idle') return;
    const interval = setInterval(() => {
      setCountdownTick((prev) => prev + 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [isMobile, mobileStage, mobileAcceptedUntil, mobileRequest, setCountdownTick]);

  useEffect(() => {
    if (!realTimeUpdates || quickCutStatus !== 'searching') return;
    const interval = setInterval(() => {
      if (typeof document !== 'undefined' && document.hidden) return;
      updateQuickCutProgress?.('searching');
    }, 2000);
    return () => clearInterval(interval);
  }, [quickCutStatus, realTimeUpdates, updateQuickCutProgress]);
};
